import api from './api';

export class LogsService {
  static async create({ action } = {}) {
    const response = await api.post("log", { action });
    return response;
  }
}